module.exports = "/_next/static/images/5d479e36bfcf164376d0977f6abadc11-smartphone.svg";